import {GameDetailsResponse} from '@app/components/game-player/types/game-player'
import Image from 'next/image'
import s from '../style.module.css'
import RetryBtn from './retry-btn'

type Props = {
  game: GameDetailsResponse
  hideDominoMenu: () => void
}

const RetrySection = ({game, hideDominoMenu}: Props) => {
  return (
    <div className={s.game_info_wrapper}>
      <Image
        alt={game.nameEn}
        src={`https://static.gamezop.com/${game.code}/m/cover.jpg`}
        objectFit='cover'
        fill
        sizes='100vw'
      />
      <RetryBtn hideDominoMenu={hideDominoMenu} />
    </div>
  )
}

export default RetrySection
